import React from 'react';
import * as Yup from "yup";
import {Grid} from '@material-ui/core';
import HotelDetails from './components/hotelDetails/HotelDetails';
import PriceDetails from './components/priceDetails/PriceDetails';
import {getTodayMidnight} from 'data/utils/shortcuts';
import OfferDetails from './components/offerDetails';
import Conditions from '../../../commons/editor/components/abstractProductDetailsForm/components/conditions';
import AbstractProductDetailsForm from '../../../commons/editor/components/abstractProductDetailsForm';
import {IHotelDetails} from 'data/interfaces/products';

export interface IHotelDetailsWithTerms extends IHotelDetails {
  acceptedTerms: boolean;
}

interface IHotelDetailsFormProps {
  hotelDetails?: IHotelDetailsWithTerms;
  onSubmit: (formValues) => Promise<any>;
}

export const hotelDetailsYupSchemaObject = Yup.object({
  hotel: Yup.object({
    id: Yup.number(),
    place_id: Yup.string().min(1).max(1000).required("יש לבחור כתובת")
  }).required("יש לבחור כתובת"),
  imagePick: Yup.array().min(1, "יש לבחור לפחות תמונה אחת").max(30).required(),
  checkInDate: Yup.number()
    .required("יש לבחור זמן כניסה למלון")
    .nullable()
    .test("checkInDate", "זמן כניסה לא יכול להיות לפני היום",
      checkInDate => getTodayMidnight().getTime() <= checkInDate),
  checkOutDate: Yup.number()
    .required("יש לבחור זמן יציאה מהמלון")
    .nullable()
    .when('checkInDate', (checkInDate, schema) => schema.test({
      test: checkOutDate => checkOutDate >= checkInDate,
      message: "זמן יציאה מהמלון לא יכול להיות לפני זמן כניסה"
    })),
  // roomType: Yup.number().min(1, "יש לבחור בסוג חדר").max(10).required("יש לבחור בסוג חדר"),
  roomsAmount: Yup.number().min(1, "יש לבחור בכמות חדרים").max(20, "לא ניתן לבחור יותר מ - 20").required("יש לבחור בכמות חדרים"),
  roomPeopleAmount: Yup.number().min(1, "יש לבחור בכמות אנשים").max(20, "לא ניתן לבחור יותר מ - 20").required("יש לבחור בכמות אנשים"),
  roomMeal: Yup.number().min(1, "יש לבחור בסוג הארוחה").max(10).required("יש לבחור בסוג הארוחה"),
  hotelDescription: Yup.string().max(10000),
  changePrice: Yup.number()
    .min(0, "מחיר שינוי לא יכול להיות שלילי")
    .max(999999, "מחיר שינוי צריך להיות נמוך מ-999999")
    .required("יש להזין את מחיר דמי השינוי לכל הכרטיסים, אם אין עלות שינוי, יש להזין 0"),
//  cancelPrice: Yup.number()
//    .min(0, "דמי ביטול לא יכול להיות שלילי")
//    .max(999999, "שמי ביטול צריך להיות נמוך מ-999999")
//    .required("יש לציין דמי ביטול, עם אין יש לרשום 0"),
  totalHotelPaidPrice: Yup.number()
    .min(1, "מחיר ששולם על המלון סך הכל נדרש להיות גבוהה מ-1")
    .max(999999, "מחיר ששולם על המלון סך הכל נדרש להיות נמוך מ-999999")
    .required("יש לציין מחיר ששולם על המלון סך הכל"),
  //hotelToBePaidPrice: Yup.number()
  //  .min(0, "מחיר שיש לשלום במלון נדרש להיות גבוהה מ-0")
  //  .max(999999, "מחיר שיש לשלום במלון נדרש להיות נמוך מ-999999")
  //  .required("יש לציין מחיר שיש לשלם במלון"),
  // vacationType: Yup.number().required("יש לבחור סוג חופשה"),
  currency: Yup.number().min(1, "יש לבחור מטבע").max(10).required("יש לבחור מטבע"),
  acceptedTerms: Yup.boolean()
    .required("Required")
    .oneOf([true], "יש לאשר את התנאים לפני השימוש"),
}).noUnknown(true);

export const hotelDetailsInitialValues = {
  imagePick: [],
  hotel: undefined,
  currency: 2,
  checkInDate: null,
  checkOutDate: null,
  hotelDescription: "",
  roomMeal: undefined,
  roomsAmount: 1,
  roomPeopleAmount: 1,
  changePrice: undefined,
//  cancelPrice: undefined,
  totalHotelPaidPrice: undefined,
  acceptedTerms: false,
//  vacationType: "",
};

export const HotelDetailsInputs = ({
                                     submitForm,
                                     submitCount,
                                     isSubmitting,
                                     setFieldValue,
                                     values,
                                     touched,
                                     errors
                                   }) => <>
  <HotelDetails values={values} submitCount={submitCount} setFieldValue={setFieldValue} errors={errors}/>
  <Grid item xs={12} style={{marginTop: 52}}/>
  <OfferDetails setFieldValue={setFieldValue} values={values as any}/>
</>;

const HotelDetailsForm = (props: IHotelDetailsFormProps) => (<AbstractProductDetailsForm
  {...props}
  initialValues={{
    ...hotelDetailsInitialValues,
    ...props.hotelDetails
  }}
  yupSchemaObject={hotelDetailsYupSchemaObject}
  formComponents={({submitForm, submitCount, isSubmitting, setFieldValue, values, touched, errors}) => (
    <>
      <HotelDetailsInputs {...{submitForm, submitCount, isSubmitting, setFieldValue, values, touched, errors}}/>
      <Grid item xs={12} style={{marginTop: 0}}/>
      <PriceDetails values={values}/>
      <Grid item xs={12} style={{marginTop: 30}}/>
      <Conditions values={values}/>
    </>
  )}
  onSubmit={(formValues) => props
    .onSubmit({
      hotelDetails: formValues
    })}
/>);

HotelDetailsForm.defaultProps = {
  hotelDetails: {},
};

export default React.memo(HotelDetailsForm);
